import React from 'react';
import { Link } from 'react-router-dom';
import InfoPage from '../components/InfoPage';
import { useAuth } from '../context/AuthContext';

const SUPPORT_EMAIL = 'support@kinetocut.com';

const faqs = [
  {
    question: 'Does KinetoCut change my original videos?',
    answer: 'No. Imported media is treated as read-only. Edits live in project data and every export creates a separate output file.',
  },
  {
    question: 'Which editing mode should I use?',
    answer: 'Easy mode is best for guided, common edits. Studio mode gives you detailed trim, color, sound, speed, and caption controls.',
  },
  {
    question: 'Why can an export take a while?',
    answer: 'Export time depends on clip length, effects, resolution, and device performance. Keep KinetoCut open until the progress screen finishes.',
  },
  {
    question: 'Can I undo an edit?',
    answer: 'Yes. The editor keeps an undo and redo history for project changes, and guided automation is designed to be reversible.',
  },
];

export default function Support() {
  const { isAuthenticated } = useAuth();
  return (
    <InfoPage
      eyebrow="Support"
      title="How can we help?"
      subtitle="Quick answers for a smoother KinetoCut workflow."
      icon="?"
      aside={(
        <>
          <span className="card-kicker">Account help</span>
          <h2>{isAuthenticated ? 'Review your profile' : 'Sign in to your account'}</h2>
          <p>{isAuthenticated ? 'Confirm your name and email from the profile page.' : 'Access your KinetoCut account or create one in a few steps.'}</p>
          <Link className="button button-primary button-full" to={isAuthenticated ? '/profile' : '/login'}>
            {isAuthenticated ? 'Open profile' : 'Sign in'}
          </Link>
          <div className="aside-note"><span>i</span><p>Never delete or overwrite source media while troubleshooting a project.</p></div>
        </>
      )}
    >
      <div className="faq-list">
        {faqs.map((item, index) => (
          <details key={item.question} open={index === 0}>
            <summary>{item.question}<span>+</span></summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
      <section style={{ marginTop: 30, paddingTop: 30, borderTop: '1px solid var(--border)' }}>
        <h2>Still need help?</h2>
        <p>Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> and we'll get back to you.</p>
      </section>
    </InfoPage>
  );
}
